import { GuestIdentityReissuedError } from '@ynap/fetch'
import { getLocale } from '@ynap/cart-state'
import getMessages from '../selectors/getMessages'
import { setCheckoutNotification } from './checkoutNotification'
import { push } from 'connected-react-router'
import type { Dispatch } from 'redux'
import type { StoreState } from 'app/state/types'

export function checkGuestIdentityError(error: unknown, dispatch: Dispatch, state: StoreState) {
    if (error instanceof GuestIdentityReissuedError) {
        const locale = getLocale(state)
        const messages = getMessages(state)
        dispatch(push(`/${locale.id}/checkout`))
        dispatch(setCheckoutNotification('info', messages.errors.guestSessionExpired(), { autoHideDelay: 5000 }))
    }
}
